import { LastPsychologist } from "utils/interfaces"

export function findFastBookingWithPsychologist(
    psychologist: LastPsychologist[] | undefined,
    hash_id: string
): LastPsychologist | undefined {
    return psychologist?.find((item) => item.hash_id === hash_id && item.allow_fast_booking)
}
